import { useReportsStore } from "@/store/modules/reports";
import { useReportTemplatesStore } from "@/store/modules/reportTemplates";
import { VITE_APP_ATMO_SERVICE_ID } from "@/env";
import { multiGuard } from "@/utils/router";

const ReportsList = () =>
  import(
    /* webpackChunkName: "ReportsList" */ "@/components/atmo/projects/project/reports/ReportsList.vue"
  );

const ReportsForm = () =>
  import(
    /* webpackChunkName: "ReportsForm" */ "@/components/atmo/projects/project/reports/ReportsForm.vue"
  );

const fetchReports = async (to, from, next) => {
  useReportsStore().fetchReports({
    serviceId: VITE_APP_ATMO_SERVICE_ID,
    projectUuid: to.params.projectId,
  });
  next();
};

const retrieveReportGenerationData = async (to, from, next) => {
  useReportsStore().retrieveReportGenerationData(to.params.reportUuid);
  next();
};

const fetchGenerationForms = async (to, from, next) => {
  const reportsStore = useReportsStore();
  const isLoaded =
    reportsStore.generationForms.length &&
    reportsStore.generationFormsProjectUuid === to.params.projectId;
  if (!isLoaded) {
    await reportsStore.fetchGenerationForms(to.params.projectId);
  }
  next();
};

const fetchReportTemplates = async (to, from, next) => {
  const reportTemplatesStore = useReportTemplatesStore();
  if (!reportTemplatesStore.reportTemplateList.length) {
    await reportTemplatesStore.fetchReportTemplates(VITE_APP_ATMO_SERVICE_ID);
  }
  next();
};

export default [
  {
    path: "",
    name: "project-reports",
    component: ReportsList,
    beforeEnter: multiGuard([fetchReports, fetchGenerationForms]),
  },
  {
    path: "form/:uuid/",
    name: "reports-form",
    component: ReportsForm,
    beforeEnter: multiGuard([fetchGenerationForms, fetchReportTemplates]),
  },
  {
    path: "form/:templateUuid/report/:reportUuid",
    name: "reports-form-edit",
    component: ReportsForm,
    beforeEnter: multiGuard([retrieveReportGenerationData]),
  },
];
